import * as React from 'react';
import { DestinationsAutocomplete } from 'lesamis-react-components';

export default class DestinationsActivities extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const { values, setFieldValue } = this.props;
    return (
      <div>
        <div className="form-group">
          <label>Destinos</label>
          <DestinationsAutocomplete
            settings={{
              endpoint: 'autocompleteCities',
              multiple: true,
              emptyOnSelect: false,
            }}
            defaultSelected={values.data.destinationsActivities}
            onSelected={(selected: any) => {
              if (!selected) {
                return;
              }
              const d = selected.map((s: any) => {
                return {
                  id: s.id,
                  name: s.name,
                  slug: s.slug,
                };
              });

              setFieldValue('data.destinationsActivities', d);
            }}
            renderOption={(option: any, i: number) => {
              return (<div key={i}>{option.name}, {option.Country.name}</div>);
            }}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/DestinationsActivities.tsx